/* eslint-disable camelcase */
import React from 'react';
import ReactTooltip from 'react-tooltip';
import { ClosedStatusChip } from '@workboard/ui-okr';
import { isCloseKeyResultEnabled } from '../../../../utils/okrFilterParams.util';

// preprocess long words (70+ chars long): abcdefghij -> ab...ij
const processLongWords = (str, maxLength = 70, margin = 30) => str
    .split(' ')
    .map((word) => {
        const { length } = word;
        return length > maxLength
            ? `${word.substring(0, margin)}...${word.substring(length - margin, length)}`
            : word
    })
    .join(' ')

const OKRPopupName = ({
    goalOwnerName,
    goal,
    teamName,
    goalPercentage,
    goalPercentageColor,
    achievedGoal,
    closed_by,
}) => {
    const isClosed = closed_by !== '0';
    const isAchieved = achievedGoal !== '0';
    const goalWithProcessedLongWords = processLongWords(goal);
    const hasTitle = goal !== goalWithProcessedLongWords; // add title in case cutoffs
    const OkrAchieveFlag = ({ achieved }) => (achieved
        ? <div className="okr_achieve_flag" aria-label="Achieved" role="img" />
        : <div className="okr_not_achieve_flag" aria-label="Not Achieved" role="img" />);

    return (
        <div className="header_name_progress_section" data-testid="header_name_progress_section">
            <div className="okr_header_name" role="heading"
                aria-level={1}
                title={hasTitle && goal ? goal : ''}>
                {isClosed ? <OkrAchieveFlag achieved={isAchieved} /> : ''}
                {goalWithProcessedLongWords}
                {isClosed && isCloseKeyResultEnabled() && <ClosedStatusChip />}
            </div>
            <div className="okr_header_owner">
                <div
                    className="okr_owner_full_name"
                    data-tip={goalOwnerName}
                    role="heading"
                    aria-level={2}
                >
                    {goalOwnerName}
                </div>
                <ReactTooltip />
                {
                    teamName
                    && <div style={{ margin: '0px 2px' }}>:</div>
                }

                <div
                    className="okr_team"
                    role="heading"
                    aria-level={2}
                >
                    { teamName && teamName.replaceAll('&amp;', '&').replaceAll('&lt;', '<').replaceAll('&gt;', '>')}
                </div>
            </div>
            <div className="okr_header_progress" data-testid="okr_header_progress">
                <div className="okr_header_progress_bar">
                    <div
                        className="okr_header_current_progress"
                        style={{ width: goalPercentage, backgroundColor: goalPercentageColor }}
                    />
                </div>
                <div className="okr_header_progress_value">
                    {goalPercentage}
                </div>
            </div>
        </div>
    )
}

export default OKRPopupName;
